// react-helmet-async lets the most recently MOUNTED <Helmet> win, not the deepest one.
// SEORobotsTag mounts late (after its registry fetch), so it can silently override a page's own
// robots decision. Pages that decide robots themselves (editorial guides, not-found) claim ownership;
// while any claim is active SEORobotsTag renders nothing.
import { useEffect, useSyncExternalStore } from 'react';

let claims = 0;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export function claimRobots() {
  claims += 1;
  emit();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    claims -= 1;
    emit();
  };
}

export function useClaimRobots() {
  useEffect(() => claimRobots(), []);
}

export function useRobotsClaimed() {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => claims > 0,
    () => false
  );
}
